
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Icon, Flex, FlexItem, FlexJustify, Size } from '@drawbotics/react-drylus';
import { css } from '@emotion/css';
import sv from '@drawbotics/drylus-style-vars';
import Playground from '~/components/Playground';
export let icons = [];
export function importAll(r) {
  r.keys().forEach(key => icons.push(r(key)));
}
export const _ = importAll(require.context('@drawbotics/icons/icons/', true, /\.svg$/));
// At build-time cache will be populated with all required modules.
export const styles = {
  icon: css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: ${sv.white};
    padding: ${sv.defaultPadding};
    margin: ${sv.marginSmall};
    color: ${sv.colorPrimary};
    transition: ${sv.transitionShort};
    &:hover {
      cursor: pointer;
      box-shadow: ${sv.elevation1};
    }
  `,
  iconBox: css`
    margin-bottom: ${sv.marginSmall};
  `
};
export const Icons = () => {
  const names = icons.map(name => name.split('.')[0].replace('/assets/', '').replace('/drylus', ''));
  return <Flex wrap mdxType="Flex">
      {names.map(name => <FlexItem key={name} flex={1 / 4} mdxType="FlexItem">
          <div className={styles.icon}>
            <div className={styles.iconBox}>
              <Icon name={name} mdxType="Icon" />
            </div>
            <div style={{
          textAlign: 'center'
        }}>{name}</div>
          </div>
        </FlexItem>)}
    </Flex>;
};

const layoutProps = {
  icons,
importAll,
_,
styles,
Icons
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





<h1>{`Icon`}</h1>
<p>{`By default the icon has no color, it inherits it from the parent component/element, unless a `}<inlineCode parentName="p">{`category`}</inlineCode>{` is specified.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Icon, Icons } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<Icon name="globe" />`} component={Icon} mdxType="Playground">
  <Icon name="globe" mdxType="Icon" />
</Playground>
<p>{`The `}<inlineCode parentName="p">{`Icons`}</inlineCode>{` object is also exposed, which is basically a mapping of the icon names (camel cased) and their value (string). This way you can do:`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Icon name={Icons.arrowUp} />
`}</code></pre>
<p>{`Here is the full set of available icons:`}</p>


<Icons mdxType="Icons" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;